import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ResponseList from "../components/ResponseList";
import { updateCurrentType } from "../services/general/actions";
import Layout from "./Layout";

function ResponseListView(props) {
  const [headerName, setHeaderName] = useState("");

  useEffect(() => {
    switch (props.currentType) {
      case "HubOrders":
        setHeaderName("Bestellingen");
        return;
      case "HubOrdersSuppliers":
        setHeaderName("Te ontvangen");
        break;
      case "Products":
        setHeaderName("Te ontvangen (Producten)");
        break;
      case "HubProducts":
        setHeaderName("Leveringen (Producten)");
        break;
      case "Orders":
        setHeaderName("Leveringen");
        break;
      case "SuppliersOrders":
        setHeaderName("Te ontvangen");
        break;
      default:
        break;
    }
  }, [props.currentType]);

  return (
    <Layout title={headerName} needsDatePicker={true}>
      {" "}
      <ResponseList />
    </Layout>
  );
}

function mapStateToProps(state) {
  return {
    currentType: state.general.currentType,
  };
}

export default connect(mapStateToProps, {
  updateCurrentType,
})(ResponseListView);
